angular.module('impactx.basket').controller('BasketDatesInputDialogCtrl', BasketDatesInputDialogCtrl);

BasketDatesInputDialogCtrl.$inject = ['$mdDialog'];

function BasketDatesInputDialogCtrl($mdDialog)
{
    var ctrl = this;

    ctrl.abort = function () {
        $mdDialog.cancel();
    };

    ctrl.apply = function () {
        $mdDialog.hide({
            date: ctrl.date,
            firstDate: ctrl.firstDate,
            lastDate: ctrl.lastDate
        })
    }
}